import Questions from './Questions';
export type { QuestionsProps } from './Questions.types';

export default Questions;
